import React from 'react';
// --- external imports -----

import renameFunction from '~/lib/renameFunction';
// --- internal imports -----


/**
 * @typedef {Object} Placement
 * @property {number} x
 * @property {number} y
 * @property {number} width
 * @property {number} height
 */


export default function withProjection(WrappedComponent, projection, opt) {
	const { displayName, ...optRest } = opt ?? {};

	function __withProjection__(props) {
		return (
			<WrappedComponent
				{...props}
				projection={projection}
				{...optRest}
			/>
		);
	}

	const _fncName_ = displayName
		?? WrappedComponent?.name
		?? WrappedComponent?.displayName
		?? WrappedComponent?.toString?.()
		?? 'Unnamed';

	return renameFunction(__withProjection__, `withProjection(${_fncName_})`);
}

